import { Box, Typography } from "@mui/material";
import React from "react";
import { VERSION } from "../../Config";

export default function Footer() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "end",
        width: "100%",
        bottom: "15px",
        // position: "absolute",
      }}
    >
      <Typography variant="body2" sx={{ color: "white" }}>
        ©2024. Loginsmedical - Quality Medical Software {VERSION}
      </Typography>
    </Box>
  );
}
